import { Box, Card, CardActions, CardContent, CardHeader, Skeleton } from '@mui/material';
import React from 'react';

import { classes } from './Feedback';

const FeedbackSkeleton = () => (
	<Card sx={classes.feedbackCard} data-testid="feedback-skeleton" variant="outlined">
		<CardHeader title={<Skeleton />} titleTypographyProps={{ className: classes.feedbackTitle }} />
		<CardContent sx={classes.feedbackCardContentRoot}>
			<Skeleton />
			<Skeleton />
			<Skeleton />
		</CardContent>
		<CardActions>
			<Box pl={1} width="100%" flexGrow={1}>
				<Skeleton width="25%" />
			</Box>
			<Skeleton width="25%" />
		</CardActions>
	</Card>
);

export default FeedbackSkeleton;
